// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"99be8af2","698":"780ba3f3","787":"c4e7f8f9","871":"c98d63a2"}[chunkId] + ".chunk.js";
};